import { Http } from "@/http"
import { Id, res_list, req_list } from '@/types/global'

export interface add_region{
    name:string
    status:number,
}

export interface region extends add_region{
    id:Id
    create_time:string
    update_time:string
}

class HttpRegion extends Http{
	get_list = (data:req_list) => {
		return this.get<res_list<region>>({...data})
	}

    get_info = (id:number) => {
        return this.get<region>({},`/admin/region/${id}/`)
    }

    create = (data:add_region) => {
        return this.post(data)
    }

    edit = ({id,...data}: region) => {
        return this.patch(data,`/admin/region/${id}/`)
    }

    del_one = (id:number) => {
        return this.delete(id)
    }
}

export const api_region =  new HttpRegion('/admin/region/')
